import React from 'react'
import { useSelector } from 'react-redux'
import MaterialInput from '../../../common/MaterialInput'
import { COUNTRY_CODES } from '../../../../consts'

const GiftingForm = ({
  errors,
  giftRecipientFirstName,
  setGiftRecipientFirstName,
  giftRecipientLastName,
  setGiftRecipientLastName,
  giftRecipientEmail,
  setGiftRecipientEmail,
  giftRecipientConfirmEmail,
  setGiftRecipientConfirmEmail,
  giftRecipientPhoneNo,
  setGiftRecipientPhoneNo,
}) => {
  const isLoadingCheckoutPage = useSelector(
    state => state?.payment?.isLoadingCheckoutPage
  )
  return (
    <>
      <div className="form-heading">
        Please enter the gift recipient information
      </div>
      <div className="form-element">
        <MaterialInput
          className="name uppercase"
          disabled={isLoadingCheckoutPage}
          type="text"
          value={giftRecipientFirstName}
          errorText={errors?.giftRecipientFirstName}
          onChange={e => setGiftRecipientFirstName(e.target.value)}
          label={'Gift Recipient First Name'}
        />
      </div>
      <div className="form-element">
        <MaterialInput
          className="name uppercase"
          disabled={isLoadingCheckoutPage}
          type="text"
          value={giftRecipientLastName}
          errorText={errors?.giftRecipientLastName}
          onChange={e => setGiftRecipientLastName(e.target.value)}
          label={'Gift Recipient Last Name'}
        />
      </div>
      <div className="form-element">
        <MaterialInput
          className="email"
          disabled={isLoadingCheckoutPage}
          type="email"
          value={giftRecipientEmail}
          errorText={errors?.giftRecipientEmail}
          onChange={e => setGiftRecipientEmail(e.target.value)}
          label={'Gift Recipient Email'}
        />
      </div>
      <div className="form-element">
        <MaterialInput
          className="email"
          disabled={isLoadingCheckoutPage}
          type="email"
          value={giftRecipientConfirmEmail}
          errorText={errors?.giftRecipientConfirmEmail}
          onChange={e => setGiftRecipientConfirmEmail(e.target.value)}
          label={'Confirm Gift Recipient Email'}
        />
      </div>
      <div className="form-element">
        <MaterialInput
          disabled={isLoadingCheckoutPage}
          countryCodes={COUNTRY_CODES}
          className="name"
          value={giftRecipientPhoneNo}
          errorText={errors?.giftRecipientPhone}
          onChange={e => setGiftRecipientPhoneNo(e)}
          label={'Gift Recipient Phone Number'}
          type="phone"
        />
      </div>
    </>
  )
}

export default GiftingForm
